import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventHeaderCaptionName, EventHeaderCaption } from './EventGroupHeader.style';
import { useAppStateContext } from 'src/appState/AppState';
import { CompetitionId } from 'src_common/common/websocket2/id/WebsocketId';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    label: string;
    selections: Array<string>;
    open: boolean;
    onToggle: () => void;
    competitionId: CompetitionId | null;
    dataTest?: string;
}

export const EventGroupHeader = observer('EventGroupHeader', (props: PropsType) => {
    const { competitionId, dataTest, label, onToggle, open, selections } = props;
    const { appSportsBookState } = useAppStateContext();
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const eventsListState = appSportsBookState.eventsListState.get(competitionId);

    const isOutrightsMarket = eventsListState.isOutrightsMarket();

    return (
        <Collapse
            dataTest={dataTest}
            isOpen={open}
            handleToggle={onToggle}
            title={label}
        >
            {open
                ? isOutrightsMarket === false &&
                  selections.map((name, key) => (
                      <EventHeaderCaption
                          key={key}
                          variant={configState.componentVariants.sportsbookVariant}
                      >
                          <EventHeaderCaptionName>{name.charAt(0).toUpperCase()}</EventHeaderCaptionName>

                          <EventHeaderCaptionName>{name}</EventHeaderCaptionName>
                      </EventHeaderCaption>
                  ))
                : null}
        </Collapse>
    );
});
